import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import locations from '../../api/hotelLocations';
import AutoComplete from '../../components/AutoComplete/AutoComplete';
import Background from '../../components/Background/Background';
import Button from '../../components/Button/Button';
import Header from '../../components/Header/Header';
import Incrementer from '../../components/Incrementer/Incrementer';
import { useAppDispatch, useAppSelector } from '../../hooks/useApp';
import {
  checkHotels,
  readyCheck,
  resetMessage,
  updateHotels
} from '../../store/slices/checksSlice';
import Modal from '../../components/Modal/Modal';

const Hotels = () => {
  const navigate = useNavigate();

  const { clientId, source } = useAppSelector((state) => state.auth);

  const { status, hotels, message, predefinedValues } = useAppSelector(
    (state) => state.checks
  );
  const dispatch = useAppDispatch();
  const [invalidRequest, setInvalidRequest] = useState(false);

  const onResultsClick = () => {
    // analytics
    analytics.track('Hotel See Results Button Clicked', {location: window.location.href, clientId, source});
    dispatch(checkHotels());
  };

  useEffect(() => {
    if (status === 'success') {
      dispatch(readyCheck());
      navigate('/success?type=hotel');
    } else if (status === 'failed' && !message) {
      dispatch(readyCheck());
      navigate('/error?type=hotel');
    } else if (message) setInvalidRequest(true);

    return () => {};
  }, [dispatch, message, navigate, status]);

  return (
    <>
      <Modal
        visible={invalidRequest}
        onClose={() => {
          setInvalidRequest(false);
          dispatch(resetMessage());
        }}
      >
        <p className='text-error font-bold text-xl'>Error.</p>
        <p>{message}</p>
      </Modal>
      <Background image='hotels' format='jpg'>
        <Header title='Hotels' />
        <div className='flex flex-col justify-start pt-12 gap-12 items-center flex-1 w-full'>
          <Incrementer
            title='# of guests'
            initialAmount={hotels.guests}
            onChange={(value) => dispatch(updateHotels({ guests: value }))}
            min={1}
            readonly={predefinedValues?.people ? true : false}
          />
          <Incrementer
            title='# of nights'
            initialAmount={hotels.nights}
            delay={0.15}
            onChange={(value) => dispatch(updateHotels({ nights: value }))}
            min={1}
            readonly={predefinedValues?.nights ? true : false}
          />
          <AutoComplete
            onChange={(value) =>
              dispatch(updateHotels({ destination: value.value }))
            }
            title='destination'
            loadOptions={locations}
            delay={0.3}
            defaultValue={hotels.destination}
            readOnly={predefinedValues?.destination ? true : false}
          />
        </div>
        <div className='flex flex-col justify-start items-center w-full'>
          <Button
            loading={status === 'loading'}
            onClick={
              !hotels.destination
                ? () => setInvalidRequest(true)
                : onResultsClick
            }
            disabled={!hotels.destination}
          >
            See Results
          </Button>
        </div>
      </Background>
    </>
  );
};

export default Hotels;
